import { render, staticRenderFns } from "./TheGallery.vue?vue&type=template&id=77337faa"
import script from "./TheGallery.vue?vue&type=script&lang=ts"
export * from "./TheGallery.vue?vue&type=script&lang=ts"
import style0 from "./TheGallery.vue?vue&type=style&index=0&id=77337faa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports